import { OBSERVABLE_PROPERTY_NAME, } from "../Observable/mod.js";
import { __isKnytReference } from "./typeGuards.js";
/**
 * Wrap a given reference, replacing its mutator with a custom one.
 *
 * @param origin$ - The reference to wrap.
 * @param mutator - The custom mutator to use. This function should be
 * pure and should not have side effects.
 *
 * @public
 */
export function replaceReferenceMutator(origin$, createMutator) {
    const mutator = createMutator(origin$);
    // We have to assume that `set value`, `set`, and `next` are equivalent.
    // This should be a safe assumption, because if they are not equivalent
    // then the reference implementation is incorrect.
    return {
        [__isKnytReference]: true,
        get value() {
            return origin$.value;
        },
        set value(value) {
            mutator(value);
        },
        // This is a detachable method.
        get: () => {
            return origin$.get();
        },
        // This is a detachable method.
        set: (value) => {
            mutator(value);
        },
        next(value) {
            mutator(value);
        },
        asReadonly() {
            return origin$.asReadonly();
        },
        subscribe(subscriber) {
            return origin$.subscribe(subscriber);
        },
        asInterop() {
            return origin$.asInterop();
        },
        [Symbol.observable]() {
            return origin$.asInterop();
        },
        [OBSERVABLE_PROPERTY_NAME]() {
            return origin$.asInterop();
        },
    };
}
